import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

export default function RequireAuth({ roles }) {
  const { user, loading } = useAuth();
  const loc = useLocation();

  // roles bəzən undefined ola bilər (sən Route elementində roles verməyəndə)
  const allowedRoles = Array.isArray(roles) ? roles : [];

  if (loading) return <div style={{ padding: 24 }}>Loading...</div>;

  // login deyil
  if (!user) return <Navigate to="/login" replace state={{ from: loc }} />;

  // roles yoxlaması tələb olunursa
  if (allowedRoles.length > 0) {
    const userRoles = Array.isArray(user?.roles) ? user.roles : [];
    const ok = userRoles.some((r) => allowedRoles.includes(r));

    if (!ok) return <Navigate to="/forbidden" replace />;
  }

  return <Outlet />;
}
